import React from 'react';

import './Upsell.scss';
import mysteryDeals from '../../../../assets/images/mystery-deals.svg';

const Upsell = ({ className = '', onClick }) => {
  return (
    <div className={`upsell-button ${className}`} onClick={onClick}>
      <img src={mysteryDeals} alt="Mystery Deals" />
    </div>
  );
};

export default Upsell;
